import styled from "styled-components";

export const DataContent = styled("div")`
  padding: 1em 0;
`;
